import fullScreen from "@/FullScreen.js"

	import debounce from 'lodash-es/debounce';
	import { ref, nextTick } from 'vue';
function InitResize(element)
{
    	!element.isSetScreenResolution && window?.addEventListener('resize', resizeHandler);
}
function SetScreenResolution(params)
{
    	const isEmpty = (obj) => (obj == null || obj == undefined || Object.keys(obj).length === 0)
    	if (!params || (!isEmpty(params?.appInfo) && !params?.document) || (!isEmpty(params?.appInfo) && params?.document == window.top.document)) return;
    	let { ratio, document = window.top.document, appInfo, scaleMode, removeEventListener = false } = params;
    	if (!ratio || !scaleMode) return;
        if (appInfo && appInfo.agentMode) return;
    	resizeParams.value = {
    		...params,
    		document,
    		scaleMode,
    		removeEventListener
    	}
    	if (removeEventListener)
    	{
    		window?.removeEventListener('resize', resizeHandler);
    		return
    	}
    	const element = document?.getElementById?.('codigger-main') || document;
    	if (!element)
    	{
    	    return;
    	}
    	let screenWidth = scaleMode === 'zoom' ? window.top.innerWidth : Math.max(window.screen.width, window.outerWidth);
    	let screenHeight = scaleMode === 'zoom' ? window.top.innerHeight : Math.max(window.screen.height, window.outerHeight);
    	const ratioMax = 10;
    	const ratioMin = 0.1;
    	const grades = [
    	    {
    	        width: 1680,
    	        strategy: (ratio) => 
    	        {
    	            return FormatRatio(ratio)
    	        }
    	    },
    	    {
    	        width: 1440,
    	        strategy: (ratio) =>
    	        {
    				let calcRatio = ratio
    	            return FormatRatio(calcRatio)
    	        }
    	    },
    	    {
    	        width: 0,
    	        strategy: (ratio) => 
    	        {
    	            let calcRatio = ratio
    				if (!isMacosSafari())
    				{
    					calcRatio = ratio;
    				}
    	            return FormatRatio(calcRatio)
    	        }
    	    }
    	];
    	const currentGrade = grades.find((grade) => screenWidth >= grade.width);
    	rawRatio = ratio;
    	ratio = +ratio || 1;
    	ratio = ratio > ratioMax ? ratioMax : (ratio < ratioMin ? ratioMin : ratio);
    	ratio = currentGrade.strategy(ratio);
    	currentRatio = ratio;
    	if (document == window.top.document)
    	{
    	    if (!fullScreen.isFullscreen)
    	    {
    	        nextTick(() =>
    	        {
    	            document.documentElement.style.overflow = 'auto';
                    document.documentElement.style.overscrollBehavior = 'auto';
    	        })
    	    }
    	    else
    	    {
    	        nextTick(() =>
    	        {
    	            document.documentElement.style.overflow = '';
    	            document.documentElement.style.overscrollBehavior = '';
    	        })
    	    }
    	    if (navigator.userAgent.indexOf('Mac OS') === -1)
    	    {
    	        nextTick(() =>
    	        {
    	            document.body.style.width = screenWidth + 'px';
    	            document.body.style.height = screenHeight + 'px';
    				if (element.style)
    				{
    					element.style.width = screenWidth / ratio + 'px';
    					element.style.height = screenHeight / ratio + 'px';
    				}
    	        })
    	    }
    		element?.style && (element.style.transform = `scale(${ratio})`);
    	}
    	else
    	{
    		if (element.style)
    		{
    	    	element.style.overscrollBehavior = 'none';
    	    	element.style.width = appInfo?.width / ratio + 'px';
    	    	element.style.height = appInfo?.height / ratio + 'px';
    			element.style.transform = `translate(${appInfo?.position?.x}px, ${appInfo?.position?.y}px) scale(${ratio})`;
    		}
    	}
    	if (element.style)
    	{
    		element.style.transformOrigin = '0 0';
    		element.style.position = 'absolute';
    		navigator.userAgent.indexOf('Mac OS') > -1 && compatMac['process'](element, document, screenWidth, screenHeight);
    		InitResize(element);
    		HandleUnload(element);
    		element.isSetScreenResolution = true;
    	}
}
function HandleUnload(element)
{
    	!element.isSetScreenResolution && element.contentWindow?.addEventListener('unload', () =>
    	{
    	    if (document == window.top.document)
    	    {
    	        nextTick(() =>
    	        {
    	            document.documentElement.style.overflow = '';
    	            document.documentElement.style.overscrollBehavior = '';
    	            document.body.style.width = '';
    	            document.body.style.height = '';
    	            element.style.width = '';
    	            element.style.height = '';
    	        })
    	    }
    	    element.isSetScreenResolution = false;
    	    element.style.transformOrigin = '';
    	    element.style.transform = '';
    	    element.style.position = '';
    	    navigator.userAgent.indexOf('Mac OS') > -1 && compatMac['unload']();
    	    window?.removeEventListener('resize', resizeHandler);
    	})
}
function FormatRatio(ratio)
{
    	return +ratio.toFixed(2);
}
	let rawRatio = 1;
	let currentRatio = 1;
	let resizeParams = ref({});
	const isMacosSafari = () =>
	{
		const ua = navigator.userAgent
		const isMac = /Macintosh/.test(ua)
		const isSafari = /Safari/.test(ua) && !/Chrome/.test(ua) && !/Edg/.test(ua) && !/OPR/.test(ua)
		return isMac && isSafari
	}
	const resizeHandler = debounce(() => {
        setScreenResolution(resizeParams.value);
    }, 500);
	const compatMac = {
	    process (element, document, screenWidth, screenHeight, scaleMode)
	    {
				nextTick(() =>
	            {
	                document.body.style.height = screenHeight + 'px';
	                document.body.style.width = screenWidth + 'px';
	                element.style.height = screenHeight / currentRatio + 'px';
	                element.style.width = screenWidth / currentRatio + 'px';
	            })
	        !element.isSetScreenResolution && window.addEventListener('resize', resizeHandler);
	    },
	    unload ()
	    {
	        window.removeEventListener('resize', resizeHandler);
	    },
	};    
	export const setScreenResolution = (params) => SetScreenResolution(params);

